import axios from "axios";
import { Base_URL } from "../url";

export const saveInvoiceHeader = async (invoiceData) => {
  try {
    const response = await axios.post(
      `${Base_URL}/Invoices/CreateInvoices`,
      invoiceData,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save invoice header";
  }
};

export const fetchCompanyCodes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/CompanyCode/GetAll`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch company codes";
  }
};

export const fetchCompnayCodesById = async (id) => {
  const data = { organisationId: id };
  try {
    const response = await axios.post(
      `${Base_URL}/CompanyCode/GetByOrganisationId`,
      data
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchCompanyCodesById = async (id) => {
  try {
    const response = await axios.get(
      `${Base_URL}/CompanyCode/GetByOrganisationId/${id}`
    );
    return response.data.data; // Return the data array directly
  } catch (error) {
    console.log("Error fetching company codes:", error);
    throw error;
  }
};

export const fetchCustomers = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/CustomerMaster/CustomerGetData`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch customers";
  }
};

export const fetchProjects = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectMaster/GetAllProjects`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch projects";
  }
};

export const fetchResources = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/SalaryProcess/ResourceMasters`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch resources";
  }
};

export const fetchResourceById = async (resourceId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/SalaryProcess/GetResourceById/${resourceId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch resource";
  }
};

export const fetchSupplyTypes = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/SupplyTypeMaster/GetAllSupplyTypes`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch supply types";
  }
};

export const fetchOfficeCodes = async () => {
  try {
    const response = await axios.get(`${Base_URL}/Office/OfficeGetData`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch office codes";
  }
};
export const fetchOfficeByOrgId = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/Office/OfficeByOrgId/${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch office codes";
  }
};

export const fetchCustomerByCode = async (customerCode) => {
  try {
    const response = await axios.get(
      `${Base_URL}/CustomerMaster/GetCustomerByCode?CustomerCode=${customerCode}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch customer details";
  }
};

export const fetchAllCountries = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/CountryMaster/GetAllCountries`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch countries";
  }
};

export const fetchRegionsByCountry = async (countryCode) => {
  try {
    const response = await axios.post(
      `${Base_URL}/RegionMaster/GetRegionsByCountry`,
      { countryCode }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch regions";
  }
};

export const fetchDistrictsByRegion = async (regionCode) => {
  try {
    const response = await axios.post(
      `${Base_URL}/DistrictMaster/GetDistrictsByRegion`,
      { regionCode }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch districts";
  }
};

export const fetchTehsilsByDistrict = async (districtCode) => {
  try {
    const response = await axios.post(
      `${Base_URL}/TehsilMaster/GetTehsilsByDistrict`,
      { districtCode }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch tehsils";
  }
};

export const fetchCitiesByTehsil = async (tehsilCode) => {
  try {
    const response = await axios.post(
      `${Base_URL}/CityMaster/GetCitiesByTehsil`,
      { tehsilCode }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch cities";
  }
};

export const saveShippingAddress = async (shippingData, userName) => {
  try {
    const response = await axios.post(
      `${Base_URL}/ShippingAddress/CreateShippingAddress?UserName=${userName}`,
      shippingData,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to save shipping address";
  }
};

export const fetchCategory = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/CategoryMaster/${id}`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchOfficeType = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/Office_Type_Master/${id}`);
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchResourceByOrgId = async (id) => {
  try {
    const response = await axios.get(
      `${Base_URL}/SalaryProcess/ResourceMastersByOrgId/${id}`
    );
    return response.data;
  } catch (error) {
    console.log(error);
  }
};

export const fetchCustomersByOrgId = async (id) => {
  try {
    const response = await axios.get(
      `${Base_URL}/CustomerMaster/getCustomersByOrgId/${id}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch customers";
  }
};

export const fetchCustomerByCustomerCode = async (customerCode) => {
  try {
    const response = await axios.get(
      `${Base_URL}/CustomerMaster/CustomerByCode/${customerCode}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch customer by code";
  }
};

export const saveInvoiceDispatchs = async (
  dispatchData,
  username,
  invoiceid
) => {
  try {
    const response = await axios.post(
      `${Base_URL}/InvoiceDispatchDetails/CreateInvoiceDispatchDetail?userName=${username}&invoiceid=${invoiceid}`,
      dispatchData,
      {
        headers: { "Content-Type": "application/json" },
      }
    );
    console.log(response, "ersdhdjv ");
    return response;
  } catch (error) {
    throw error.response?.data || "Failed to save invoice header";
  }
};

export const fetchCustomerCode = async (id) => {
  console.log(id, "we get from inv id");
  try {
    const response = await axios.get(`${Base_URL}/Invoices/${id}`);
    console.log(response, "response");
    return response?.data?.customerCode;
  } catch (error) {
    throw error.response?.data || "Failed to fetch customers";
  }
};

export const fetchCurrency = async () => {
  try {
    const response = await axios.get(
      `${Base_URL}/CurrencyMaster/GetAllCurrencies`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch customers";
  }
};

export const fetchProjectTypes = async (id) => {
  try {
    const response = await axios.get(`${Base_URL}/ProjectType/id?id=${id}`);
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch projectTypes";
  }
};

export const fetchProjectTypeById = async (projectTypeId) => {
  try {
    const response = await axios.get(
      `${Base_URL}/ProjectType/GetProjectTypeById/${projectTypeId}`
    );
    return response.data;
  } catch (error) {
    throw error.response?.data || "Failed to fetch project type";
  }
};
